import { ref, computed } from 'vue';

const ACCESS_TOKEN_KEY = 'portal_access_token';
const REFRESH_TOKEN_KEY = 'portal_refresh_token';

const _loggedIn = ref(!!localStorage.getItem(ACCESS_TOKEN_KEY));
export const portalLoggedIn = computed(() => _loggedIn.value);

export function getPortalAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY) || '';
}

export function getPortalRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY) || '';
}

export function setPortalTokens(accessToken: string, refreshToken: string) {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  _loggedIn.value = true;
}

export function clearPortalTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  _loggedIn.value = false;
}

export function isPortalLoggedIn() {
  return portalLoggedIn.value;
}
